<style>
</style>

<template>
<div id="payment--conf">
  <router-view></router-view>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('Děkujeme za nákup. Budete přesměrování zpět do naší aplikace...') }}</span>
      </v-card-title>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
export default {
  name: 'ConfirmPage',
  data() {
    return {
      dialog: false
    }
  },
  props: ['query'],
  mounted() {
    this.dialog = true
    let fullQuery = ''
    if (this.query !== null && this.query !== undefined) {
      for (const key in this.query) {
        if (fullQuery.length > 0) {
          fullQuery = fullQuery + '&'
        }
        fullQuery = fullQuery + key + '=' + this.query[key]
      }
    }
    this.$fetch('basket/payments?' + fullQuery, {
        method: 'PUT'
      })
      .then(() => this.delayClose())
      .catch(() => console.log('payment finish error'))
      .finally(() => this.$router.push({
        name: 'customer',
        params: {
          selected: 'orders'
        }
      })).catch(console.log)
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    delayClose() {
      this.timer = setTimeout(() => {
        this.dialog = false
      }, 3000)
    }
  }
}
</script>
